import Vue from 'vue'
import Router from 'vue-router'

// Dashboard Components
import dashboard from '../views/dashboard'

// Widgets
import widgets from '../views/widgets'

// UI Components
import alerts from '../views/ui-components/alerts'
import badges from '../views/ui-components/badges'
import breadcrumbs from '../views/ui-components/breadcrumbs'
import buttons from '../views/ui-components/buttons'
import carousel from '../views/ui-components/carousel'
import dropdowns from '../views/ui-components/dropdowns'
import icons from '../views/ui-components/icons'
import modals from '../views/ui-components/modals'
import paginations from '../views/ui-components/paginations'
import progress from '../views/ui-components/progress'
import tables from '../views/ui-components/tables'
import typography from '../views/ui-components/typography'
import tabs from '../views/ui-components/tabs'
import tooltips from '../views/ui-components/tooltips'

// Form Components
import forms from '../views/forms/forms'
import viewlist from '../views/forms/viewlist'
import userlist from '../views/forms/userlist'
import editsnake from '../views/forms/editsnake'
import newuserlist from '../views/forms/newuserlist'
import rescuerlist from '../views/forms/rescuerlist'
import rescuerapproval from '../views/forms/rescuerapproval'
import locations from '../views/forms/locations.vue'
import snakedetails from '../views/forms/snakedetails.vue'
import addexperts from '../views/forms/addexperts.vue'
import expertslist from '../views/forms/expertslist.vue'
import viewlistexperts from '../views/forms/viewlistexperts.vue'
import snakebitereports from '../views/forms/snakebitereports.vue'
import addhospital from '../views/forms/addhospital.vue'
import viewhospital from '../views/forms/viewhospital.vue'
import identifyview from '../views/forms/identifyview.vue'
import identifyreply from '../views/forms/identifyreply.vue'
import identifyviewdetails from '../views/forms/identifyviewdetails.vue'
import pendinghospital from '../views/forms/pendinghospital.vue'
import hospitalmap from '../views/forms/hospitalmap.vue'
import rescuermap from '../views/forms/rescuermap.vue'
import usermap from '../views/forms/usermap.vue'
import snakebitemanagement from '../views/forms/snakebitemanagement.vue'
import viewsnakebitemanagement from '../views/forms/viewsnakebitemanagement.vue'
import snakereports from '../views/forms/snakereports'
import edithospital from '../views/forms/edithospital'
import toprescuers from '../views/forms/toprescuers'
import toprescuersyear from '../views/forms/toprescuersyear'
import topcommonsnakes from '../views/forms/topcommonsnakes'
import editsnakebitemanagement from '../views/forms/editsnakebitemanagement'
import snakebitemanagementview from '../views/forms/snakebitemanagementview'
import editusers from '../views/forms/editusers'
import editrescuers from '../views/forms/editrescuers'
import pendingrescuerdetails from '../views/forms/pendingrescuerdetails'
import rescuerdetails from '../views/forms/rescuerdetails'
import deleteoperations from '../views/forms/deleteoperations'
import traininglist from '../views/forms/traininglist'
import deletelocations from '../views/forms/deletelocations'

import error404 from '../views/sample-pages/error-404'
import error500 from '../views/sample-pages/error-500'
import login from '../views/sample-pages/login'
// import sarpavideo from '../views/sample-pages/sarpavideo'
import register from '../views/sample-pages/register'
import mapcheck from '../views/forms/mapcheck'
import pending from '../views/forms/operation/pending'
import approve from '../views/forms/operation/approve'
import approvedList from '../views/forms/operation/approvedList'
import approvedDetails from '../views/forms/operation/approvedDetails'
import released from '../views/forms/operation/released'
import assign from '../views/forms/operation/assign'
import rescue from '../views/forms/operation/rescue'
import assigned from '../views/forms/operation/assigned'
import rescueDetails from '../views/forms/operation/rescueDetails'



import store from '../store'

Vue.use(Router)

let router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    // {
    //   path: '/sarpavideo',
    //   name: 'sarpavideo',
    //   component: sarpavideo
    // },
    {
    path: '/',
    name: 'dashboard',
    component: dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/widgets',
    name: 'widgets',
    component: widgets
  },
  {
    path: '/404',
    name: 'error-404',
    component: error404
  },
  {
    path: '/500',
    name: 'error-500',
    component: error500
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  
  {
    path: '/sarpavideo',
    name: 'register',
    component: register
  },
  {
    path: '/alerts',
    name: 'alerts',
    component: alerts
  },
  {
    path: '/badges',
    name: 'badges',
    component: badges
  },
  {
    path: '/breadcrumbs',
    name: 'breadcrumbs',
    component: breadcrumbs
  },
  {
    path: '/buttons',
    name: 'buttons',
    component: buttons
  },
  {
    path: '/carousel',
    name: 'carousel',
    component: carousel
  },
  {
    path: '/dropdowns',
    name: 'dropdowns',
    component: dropdowns
  },
  {
    path: '/icons',
    name: 'icons',
    component: icons
  },
  {
    path: '/modals',
    name: 'modals',
    component: modals
  },
  {
    path: '/paginations',
    name: 'paginations',
    component: paginations
  },
  {
    path: '/progress',
    name: 'progress',
    component: progress
  },
  {
    path: '/tables',
    name: 'tables',
    component: tables
  },
  {
    path: '/typography',
    name: 'typography',
    component: typography
  },
  {
    path: '/tabs',
    name: 'tabs',
    component: tabs
  },
  {
    path: '/tooltips',
    name: 'tooltips',
    component: tooltips
  },
  {
    path: '/forms',
    name: 'forms',
    component: forms
  },
  {
    path: '/viewlist',
    name: 'viewlist',
    component: viewlist
  },
  {
    path: '/identifyview',
    name: 'identifyview',
    component: identifyview
  },
  {
    path: '/viewlistexperts',
    name: 'viewlistexperts',
    component: viewlistexperts
  },
  {
    path: '/userlist',
    name: 'userlist',
    component: userlist
  },
  {
    path: '/newuserlist',
    name: 'newuserlist',
    component: newuserlist
  },
  {
    path: '/rescuerlist',
    name: 'rescuerlist',
    component: rescuerlist
  },
  {
    path: '/toprescuers',
    name: 'toprescuers',
    component: toprescuers
  },
  {
    path: '/traininglist',
    name: 'traininglist',
    component: traininglist
  },
  {
    path: '/deletelocations',
    name: 'deletelocations',
    component: deletelocations
  },
  {
    path: '/toprescuersyear',
    name: 'toprescuersyear',
    component: toprescuersyear
  },
  {
    path: '/topcommonsnakes',
    name: 'topcommonsnakes',
    component: topcommonsnakes
  },
  {
    path: '/expertslist',
    name: 'expertslist',
    component: expertslist
  },
  {
    path: '/deleteoperations',
    name: 'deleteoperations',
    component: deleteoperations
  },
  {
    path: '/rescuerapproval',
    name: 'rescuerapproval',
    component: rescuerapproval
  },
  {
    path: '/locations',
    name: 'locations',
    component: locations
  },
  {
    path: '/snakebitereports',
    name: 'snakebitereports',
    component: snakebitereports
  },
  {
    path: '/addexperts',
    name: 'addexperts',
    component: addexperts
  },
  {
    path: '/editsnake/:id',
    name: 'editsnake',
    component: editsnake,
    props: true
  },
  {
    path: '/edithospital/:id',
    name: 'edithospital',
    component: edithospital,
    props: true
  },
  {
    path: '/editusers/:id',
    name: 'editusers',
    component: editusers,
    props: true
  },
  {
    path: '/editrescuers/:id',
    name: 'editrescuers',
    component: editrescuers,
    props: true
  },
  {
    path: '/identifyreply/:id',
    name: 'identifyreply',
    component: identifyreply,
    props: true
  },
  {
    path: '/identifyviewdetails/:id',
    name: 'identifyviewdetails',
    component: identifyviewdetails,
    props: true
  },
  {
    path: '/addhospital',
    name: 'addhospital',
    component: addhospital
  },
  {
    path: '/viewhospital',
    name: 'viewhospital',
    component: viewhospital
  },
  {
    path: '/pendinghospital',
    name: 'pendinghospital',
    component: pendinghospital
  },
  {
    path: '/hospitalmap',
    name: 'hospitalmap',
    component: hospitalmap
  },
  {
    path: '/rescuermap',
    name: 'rescuermap',
    component: rescuermap
  },
  {
    path: '/snakereports',
    name: 'snakereports',
    component: snakereports
  },
  {
    path: '/usermap',
    name: 'usermap',
    component: usermap
  },
  {
    path: '/snakebitemanagement',
    name: 'snakebitemanagement',
    component: snakebitemanagement
  },
  {
    path: '/editsnakebitemanagement/:id',
    name: 'editsnakebitemanagement',
    component: editsnakebitemanagement,
    props: true
  },
  {
    path: '/snakebitemanagementview/:id',
    name: 'snakebitemanagementview',
    component: snakebitemanagementview,
    props: true
  },
  {
    path: '/viewsnakebitemanagement',
    name: 'viewsnakebitemanagement',
    component: viewsnakebitemanagement
  },
  {
    path: '/mapcheck',
    name: 'mapcheck',
    component: mapcheck
  },
  {
    path: '/snakedetails/:id',
    name: 'snakedetails',
    component: snakedetails,
    props: true
  },
  {
    path: '/pendingrescuerdetails/:id',
    name: 'pendingrescuerdetails',
    component: pendingrescuerdetails,
    props: true
  },
  {
    path: '/rescuerdetails/:id',
    name: 'rescuerdetails',
    component: rescuerdetails,
    props: true
  },
  // .............Operation Section................
  {
    path: '/pending',
    name: 'pending',
    component: pending,
  },
  {
    path: '/assign/:id',
    name: 'assign',
    component: assign,
    props:true
  },
  {
    path: '/approve/:id',
    name: 'approve',
    component: approve,
    props:true
  },
  {
    path: '/rescueDetails/:id',
    name: 'rescueDetails',
    component: rescueDetails,
    props:true
  },
  {
    path: '/released',
    name: 'released',
    component: released,
  },
  {
    path: '/rescue',
    name: 'rescue',
    component: rescue,
  },
  {
    path: '/assigned',
    name: 'assigned',
    component: assigned,
  },
  {
    path: '/approvedList',
    name: 'approvedList',
    component: approvedList,
    props:true
  },
  {
    path: '/approvedDetails/:id',
    name: 'approveddDetails',
    component: approvedDetails,
    props:true
  },

],
scrollBehavior() {
  document.getElementById('app').scrollIntoView();
}
})

router.beforeEach((to, from, next) => {
  // check if the route requires authentication and user is not logged in
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    // redirect to login page
    next({
      name: 'login'
    })
    return
  }

  // if logged in redirect to dashboard
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({
      path: '/'
    })
    return
  }

  // if trying to navigate to a protected page after logout, prevent navigation
  if (!store.state.isLoggedIn && to.matched.some(route => route.meta.requiresAuth)) {
    next(false) // Cancels the navigation
  }
  
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js